import { render, staticRenderFns } from "./all-other-earnings-charges.vue?vue&type=template&id=1b125e2a"
import script from "./all-other-earnings-charges.vue?vue&type=script&lang=js"
export * from "./all-other-earnings-charges.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports